import { Component, DoCheck, EventEmitter, Input, IterableDiffers, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxScrollViewComponent, DxScrollViewModule } from 'devextreme-angular';
import { ChatMessage } from '../models/chat-message.model';
import { ChatMessageComponent } from '../chat-message/chat-message.component';

@Component({
  selector: 'nida-web-chat-log',
  imports: [CommonModule, DxScrollViewModule, ChatMessageComponent],
  templateUrl: './chat-log.component.html',
  styleUrl: './chat-log.component.scss',
})
export class ChatLogComponent implements DoCheck {
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;

  @Input() chatMessages: ChatMessage[] = [];

  @Output() initialScroll = new EventEmitter<void>();

  private initialScrollDone = false;

  private iterableDiffer;

  constructor(iterableDiffers: IterableDiffers) {
    this.iterableDiffer = iterableDiffers.find([]).create(undefined);
  }

  ngDoCheck() {
    const changes = this.iterableDiffer.diff(this.chatMessages);
    if (changes) {
      // Delay the scrolling so that the new messages could be rendered
      setTimeout(() => {
        this.scrollView.instance.scrollTo(this.scrollView.instance.scrollHeight());

        if (!this.initialScrollDone) {
          this.initialScrollDone = true;
          this.initialScroll.next();
        }
      }, 50);
    }
  }

  protected trackByChatMessage(_: number, chatMessage: ChatMessage) {
    return JSON.stringify({
      message: chatMessage.message,
      transmissionTime: chatMessage.transmissionTime,
      senderId: chatMessage.senderId,
    });
  }
}
